<template>
    <div id="viewDiv" ></div>
</template>
<script>
/* ///////stu commented this section out 12/27/2021
import router from '../router';
*/
import { loadModules } from 'esri-loader'
import {mapState} from 'vuex'
export default {
  data ({ req }) {
     return {
      name: req ? 'server' : 'client'
    }
  },
  head () {
    return {
      title: `Map Page (${this.name}-side)`
    }
  },
computed:{
...mapState(['basemap','map','center','extent','zoom','municipalID','SheetName']),
 SheetName: {
      get() {
        return this.$store.state.SheetName;
      },
      set(value) {
        this.$store.commit('updateSheetName', value);
      },
    },
  municipalID: {
      get() {
        return this.$store.state.municipalID;
      },
      set(value) {
        this.$store.commit('updateMunicipalID', value);

      },
    }

},
  mounted () {
    var _vue = this // << here
    
   //  console.log('map: mounted')
    loadModules([
      'esri/WebMap',
      'esri/views/MapView',
      "esri/layers/GraphicsLayer",
      "esri/tasks/QueryTask",
      "esri/tasks/support/Query",
      "esri/layers/TileLayer",
      "esri/layers/FeatureLayer",
      
      'esri/core/watchUtils',
      "dojo/_base/array",
    ]).then(([EsriMap, MapView,GraphicsLayer,QueryTask,Query,TileLayer,FeatureLayer, watchUtils, arrayUtils]) => {
      
        // create map with the given options at a DOM node w/ id 'mapNode'
        var taxSheetURL = "https://morrisgisapps.co.morris.nj.us/arcgis105/rest/services/ParcelSearcher/TaxSheets/FeatureServer/1"
        var basMapLayer = new TileLayer({
            url: "https://morrisgisapps.co.morris.nj.us/arcgis105/rest/services/caches/BaseMap/MapServer"
          });

/*		////////// stu commented this section out 12/27/2021

        var orthoMapLayer = new TileLayer({
            url: "https://morrisgisapps.co.morris.nj.us/arcgis105/rest/services/caches/NJDEP2015_AerialCache/MapServer"
          });  

*/

          

        // Create graphics layer and symbol to use for displaying the results of query
        var resultsLyr = new GraphicsLayer();
        
        /*****************************************************************
              *  Point QueryTask to URL of feature service
        *****************************************************************/
 //       var qTask = new QueryTask({url: taxSheetURL});

        /******************************************************************
        * Set the query parameters to always return geometry and all fields.
        * Returning geometry allows us to display results on the map/view
        ******************************************************************/
    //    var params = new Query({
   //         returnGeometry: true,
   //         outFields: ["*"]
   //       });


        var taxSheetlayer = new FeatureLayer({
            url: taxSheetURL,
            outFields: ["OBJECTID","DetailSheet","MunicipalID"],
            visible: false
          });



/*		////////// stu commented this section out 12/27/2021
        // Create a symbol for rendering the graphic
        const fillSymbol = {
                type: "simple-fill", // autocasts as new SimpleFillSymbol()
                color: [227, 139, 79, 0.8],
                outline: { // autocasts as new SimpleLineSymbol()
                color: [255, 255, 255],
                width: 1
                }
              };
*/
        /******************************************************************
        * Load the map.
        * 
        ******************************************************************/
        let map
        if (!this.$store.state.map) 
          {
            map = new EsriMap({
              layers: [basMapLayer, resultsLyr]
              })
            this.$store.state.map = map
          } 
        else 
          {
            map = this.$store.state.map
          }
              
        /******************************************************************
        * Load the view.
        * 
        ******************************************************************/              
        const view = new MapView({
            container: 'viewDiv',
            map,
            center:this.$store.state.center,
            zoom: this.$store.state.zoom
            })

        //*******************************************************************
        // Watching properties for changes
        // 1. Watch view.stationary property
        // 2. set center,extent and zoom properties in store
        //*******************************************************************
        // Watch view's stationary property for becoming true.
        watchUtils.whenTrue(view, "stationary", function() {
            // Get the new center of the view only when view is stationary.
            if (view.center) 
              {
                  let ctr = [view.center.x,view.center.y ]
                  _vue.$store.dispatch('updateCenter', ctr); 
              }

            // Get the new extent of the view only when view is stationary.
            if (view.extent) 
              {
                var ext = new  Object();
                ext.xmin = view.extent.xmin,
                ext.xmax = view.extent.xmax,
                ext.ymin = view.extent.ymin,
                ext.ymax = view.extent.ymax;
                ext.spatialReference =  {'wkid': 3424}
                _vue.$store.dispatch('updateExtent', ext); 
              }

            // Get the new extent of the view only when view is stationary.
            if (view.zoom) 
              {
                var zm = view.zoom
                _vue.$store.dispatch('updateZoom', zm); 
              }
          });

            
        //*******************************************************************
        // Set up event handler for map "click" to select tam sheet
        // 1. Define event
        // 2. Execute spatial query on layer
        //*******************************************************************        
        view.on("click", eventHandler);

        function eventHandler(event) {
            resultsLyr.removeAll();
            
            var queryTask = new QueryTask({url: taxSheetURL });
            var query = new Query({
                  geometry: event.mapPoint, // mapPoint obtained from view-click event
                  outFields:["OBJECTID","DetailSheet","MunicipalID"],
                  distance: 10,
                  units: "feet",
                  spatialRelationship: "intersects", // All features that intersect 100 foot buffer
                  returnGeometry: true
                });
            
            queryTask.execute(query).then(function(results){
                displayResults(results);
                let attrs = results.features[0].attributes;
                let ts = attrs.DetailSheet
                let muni = attrs.MunicipalID
                
                _vue.$store.dispatch('mapSelect', {ts, muni}); 
              });
          }




        //*******************************************************************
        // Set up event handlers for controls that will interact with 
        // the map - after the map is ready
        // 1. Define the municipal drop down event to listen for changes in municipality.
        // 2. Define the tax sheet drop down event to listen for changes in map sheet.
        //*******************************************************************  
        view.when(function() {
            var m = document.querySelector("#municipality");
            m.addEventListener("change", updateMapExtent);

            var sheetlist = document.querySelector("#taxsheet");
            sheetlist.addEventListener("change", selectMapSheet);
           
           
          // const muni =this.$route.params.muni;
          //  const ts = this.$route.params.ts;
          //   _vue.$store.dispatch('routeInit', {ts, muni}); 
          //   alert('ts,muni');
             selectMapSheet();
          });

        function selectMapSheet(){
        //function selectMapSheet(event){       //stu 12/27/2021
            resultsLyr.removeAll();
         //   alert('selectMapSheet: ' + _vue.municipalID + ', ' + _vue.SheetName );
            if (_vue.SheetName.search(/e/i)<0 ){
            var q = "MunicipalID = '" + _vue.municipalID + "' AND DetailSheet = '" +  _vue.SheetName + "'";
          // alert(q);
           queryTaxSheets(q).then(displayResults);}
            else{

              updateMapExtent();
            }
          }

        function queryTaxSheets(q) {
            var query = taxSheetlayer.createQuery();
            query.where = q;
            return taxSheetlayer.queryFeatures(query);
          }

        // Called each time the promise is resolved
        function displayResults(response) {
            // Loop through each of the results and assign a symbol 
            // to each so they may be visualized on the map
           // alert('display results')
            var searchResults = arrayUtils.map(response.features, function(
              feature) {
                  // Sets the symbol of each resulting feature with a fixed color and width. 
                feature.symbol = {
                    type: "simple-fill", // autocasts as new PointSymbol3D()
                    color: [227, 139, 79, 0.8],
                    outline: { // autocasts as new SimpleLineSymbol()
                      color: [255, 255, 255],
                      width: 1
                      }
                    };
              return feature;
              });

            resultsLyr.addMany(searchResults);

            // animate to the results after they are added to the map
            view.goTo(searchResults).then(function() {
                  view.zoom = view.zoom-2;
                });
          }
/*		////////// stu commented this section out 12/27/2021
        // Called each time the promise is rejected
        function promiseRejected(err) {
            console.error("Promise rejected: ", err.message);
          }
*/
        function updateMapExtent(){
        //function updateMapExtent(event){    //stu 12/27/2021
            var ext = _vue.extent
            view.extent = ext;
          }

   })
  },
 // beforeDestroy () {
 //     console.log('map: beforeDestroy')
 //     this.$store.state.watchHandle.remove()
 //   }
}
</script>

<style scoped>
#viewDiv {
  height: 300px;
  width: calc(100%-6px);
  max-width: 400px;
  margin:3px;
  background: white;
  overflow: hidden;
}
.esri-view-root {
  height: 200px;
  width: calc(100%-6px);
  max-width: 400px;
  margin:3px;
}

/* Media Queries
/* For smaller devices, switch to single column layout
/* ========================================*/ 
@media all and (max-width : 700px) {
 #viewDiv {
  height: 40vh;
  width: 100%;
  margin:2px;
  background: white;
}
}

</style>